import React from "react";
import { Link } from "react-router-dom";
import "./header.css";
import { history } from "../../helpers/history";
import Avatar from "react-avatar";
import axios from "axios";
import api from "../../routes/api";
import Oval from "../../assets/img/icons/common/beauty.jpeg";
import Oval1 from "../../assets/img/icons/common/Oval.png";
import Ovala from "../../assets/img/icons/common/beautya.jpg";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import {
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  ListGroupItemHeading,
} from "reactstrap";
import socket from "../../helpers/socket";
import toast, { Toaster } from "react-hot-toast";
import { format } from "timeago.js";
import { TiTick } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import { IconButton, Card } from "@mui/material";
import { FaPowerOff } from "react-icons/fa";
import {
  Bar,
  SvgFeed,
  SvgMyNetWork,
  SvgDating,
  SvgMarketPlace,
  SvgJob,
  SvgEvent,
  SvgGroup,
  SvgArticle,
} from "./svg/svg";

import UserSolid from "../Dating/UI/icon/user-solid.svg";

const withNavigate = (Component) => (props) => {
  const navigate = useNavigate();
  return <Component {...props} navigate={navigate} />;
};

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: {},
      reqData: [],
      allNotifications: [],
      show: false,
      toggle: false,
      isNotUser: false,
      notificationToggle: false,
      profileDropDown: false,
    };
    this.socket = socket;
    this.notiDropDownRef = React.createRef();
    this.userDropDownRef = React.createRef();
  }

  arr = [];
  arr2 = [];
  isOnline;

  borderTop = async (myclass) => {
    let elms = document.getElementsByClassName(myclass);
    for (var i = 0; i < elms.length; i++) {
      elms[i].style.borderTop = "2px solid #545AF2";
    }
  };
  toggle = async () => {
    this.setState({ show: !this.state.show });
  };
  ProfileNavigate = async () => {
    const { navigate } = this.props;
    navigate("/my-profile");
  };
  NetworkNavigate = async () => {
    const { navigate } = this.props;
    navigate("/connect");
  };
  dropownToggle = async () => {
    this.setState((pre) => ({
      ...pre,
      toggle: true,
      notificationToggle: !this.state.notificationToggle,
    }));
    this.getRequestData();
  };
  configureSocket() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user !== null) {
      this.isOnline = user.data.data.isOnline;
    } else {
      this.socket?.on("disconnect", (data) => {
        this.socket?.on("k", (data) => {
          this.isOnline = data.isOnline;
        });
      });
    }
  }
  getUserData = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const result = await axios({
      method: "GET",
      url: api.getProfileData + `/${user.data.data.id}`,
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result.data.success) {
      this.setState({ userData: result.data.result });
    } else {
      this.setState({
        userData: {
          firstname: "",
          lastname: "",
          bio: "",
          hobbies: [],
          username: "",
          email: "",
          image: [],
        },
      });
    }
  };

  getRequestData() {
    const user = JSON.parse(localStorage.getItem("user"));
    this.socket?.on("notify-request", (data) => {
      console.log(data, "notify user");
      if (data != null) {
        this.arr.push(data);
        this.arr.forEach((element) => {
          if (element.receiverId == user.data.data.id) {
            this.arr = [];
            this.arr.push(element);
          }
        });
        this.setState({ reqData: this.arr });
      } else {
        this.setState({ reqData: [] });
      }
    });
  }

  readNotification = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const userId = user.data.data.id;
    const result = await axios({
      method: "POST",
      url: api.getNotification,
      data: {
        id: id,
        action: "read",
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result.data.success) {
      toast.success(result.data.message, {
        position: "top-right",
        duration: 4000,
      });
    } else {
      /*toast.error(result.data.message, {
        position: "top-right",
        duration: 4000,
      }); */
    }
  };

  readAllNotifications = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const userId = user.data.data.id;
    const result = await axios({
      method: "POST",
      url: api.getNotification,
      data: {
        action: "readAll",
        receiverId: user.data.data.id,
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result.data.success) {
      //console.log(result.data, "<<<< read all notifications and deleted");
      /*toast.success(result.data.message, {
        position: "top-right",
        duration: 4000,
      });*/
    } else {
      /*toast.error(result.data.message, {
        position: "top-right",
        duration: 4000,
      });*/
    }
  };

  fetchNotification = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user.data.token;
    const userId = user.data.data.id;
    const result = await axios({
      method: "POST",
      url: api.getNotification,
      data: {
        receiverId: userId,
        action: "fetch",
      },
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    if (result.data.success) {
      this.setState({
        allNotifications: result.data.data,
      });
    } else {
      this.setState({
        allNotifications: [],
      });
    }
  };
  socketJoin = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user != null) {
      let notify = {
        userId: user.data.data.id,
      };
      this.socket?.emit("notification", notify);
    }
  };
  componentDidMount() {
    const user = localStorage.getItem("user");
    document.addEventListener("mousedown", this.handleClickOutside);
    if (!user) {
      this.setState({
        isNotUser: true,
      });
    }

    if (user != null) {
      this.getUserData();
      this.socketJoin();
      this.fetchNotification();
      this.socket?.on("connection", () => {});
      this.getRequestData();
    }
  }

  handleClickOutside = (event) => {
    if (
      this.state.notificationToggle &&
      this.notiDropDownRef.current &&
      !this.notiDropDownRef.current.contains(event.target)
    ) {
      return this.setState({ notificationToggle: false });
    }
    if (
      this.state.profileDropDown &&
      this.userDropDownRef.current &&
      !this.userDropDownRef.current.contains(event.target)
    ) {
      return this.setState({ profileDropDown: false });
    }
  };

  logout() {
    const user = JSON.parse(localStorage.getItem("user"));
    this.socket?.emit("logout", user.data.data.id);
    localStorage.clear();
    const { navigate } = this.props;
    navigate("/login");
    window.location.reload();
  }

  addFollower = async (id, requestAction) => {
    const user = JSON.parse(localStorage.getItem("user"));
    console.log(id);
    const token = user.data.token;
    const result = await axios({
      url: api.addFollower + `/${id}/${user.data.data.id}`,
      method: "POST",
      data: {
        requestActionType: requestAction,
      },

      headers: {
        Authorization: "Bearer " + token,
      },
    });
    console.log(result, "add follower");
    if (result.data.success) {
      toast.success(result.data.message);
    } else {
      toast.error(result.data.message);
    }
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    return (
      <>
        <div className="header-box">
          <div className="d-block d-lg-none">
            <div className="bar-click">
              {this.state.show ? (
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => {
                    this.toggle();
                  }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.5188 29.2311C26.5439 30.2563 28.2062 30.2563 29.2314 29.2311C30.2562 28.2059 30.2562 26.5437 29.2314 25.5185L18.7127 14.9999L29.231 4.48138C30.2562 3.45622 30.2562 1.79412 29.231 0.768927C28.2062 -0.256227 26.5439 -0.256227 25.5188 0.768927L15.0001 11.2877L4.4814 0.768892C3.45621 -0.256297 1.79409 -0.256297 0.768931 0.768892C-0.256264 1.79405 -0.256264 3.45615 0.768931 4.48134L11.2875 14.9999L0.768896 25.5185C-0.256299 26.5437 -0.256299 28.2059 0.768896 29.2311C1.79406 30.2563 3.45617 30.2563 4.48137 29.2311L15.0001 18.7125L25.5188 29.2311Z"
                    fill="#10182B"
                  />
                </svg>
              ) : (
                <div
                  onClick={() => {
                    this.toggle();
                  }}
                >
                  <Bar />
                </div>
              )}
            </div>
            {/*---------------Responsive Menu Bar-------------------*/}
            {this.state.show ? (
              <div className="rspnsv-bar">
                <Card>
                  <ul>
                    <li className="btn btn-lg">
                      <Link className="p-0" to="/home">
                        <SvgFeed />
                        <p className="poppins mb-0 ml-2">Feed</p>
                      </Link>
                    </li>
                    <li className="btn btn-lg">
                      <Link
                        to="/marketplace"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <SvgMarketPlace />
                        <p className="poppins mb-0">Marketplaces</p>
                      </Link>
                    </li>
                    <li className="btn btn-lg">
                      <Link
                        to="/jobs"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <SvgJob />
                        <p className="poppins mb-0">Jobs</p>
                      </Link>
                    </li>
                    <li className="btn btn-lg">
                      <Link
                        to="/connect"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <SvgMyNetWork />
                        <p className="poppins mb-0 ">Network</p>
                      </Link>
                    </li>
                    {/*<li className="btn btn-lg">
                      <Link
                        to="/dating"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        {" "}
                        <SvgDating />
                        <p className="poppins mb-0 ">Meetup</p>
                      </Link>
                    </li>*/}
                    <li className="btn btn-lg">
                      <Link
                        to="/pages"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="#999999"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24.5833 22.5H22.0833V13.7025C22.2202 13.7327 22.3598 13.7486 22.5 13.75C23.65 13.7486 24.582 12.8167 24.5833 11.6667C24.5833 11.6362 24.58 11.6059 24.5733 11.5763L23.74 7.82625C23.6976 7.63563 23.5286 7.50005 23.3333 7.5H22.0833V6.25C22.0833 6.0199 21.8968 5.83333 21.6667 5.83333H18.3333V5H19.1667C19.3968 5 19.5833 4.81344 19.5833 4.58333V0.416667C19.5833 0.186562 19.3968 0 19.1667 0H5.83333C5.60323 0 5.41667 0.186562 5.41667 0.416667V4.58333C5.41667 4.81344 5.60323 5 5.83333 5H6.66667V5.83333H3.33333C3.10323 5.83333 2.91667 6.0199 2.91667 6.25V7.5H1.66667C1.47141 7.50005 1.30234 7.63563 1.26 7.82625L0.426667 11.5763C0.42 11.6059 0.416667 11.6362 0.416667 11.6667C0.418021 12.8167 1.35 13.7486 2.5 13.75C2.64016 13.7486 2.77979 13.7327 2.91667 13.7025V22.5H0.416667C0.186562 22.5 0 22.6866 0 22.9167V24.5833C0 24.8134 0.186562 25 0.416667 25H24.5833C24.8134 25 25 24.8134 25 24.5833V22.9167C25 22.6866 24.8134 22.5 24.5833 22.5ZM23 8.33333L23.75 11.7083C23.7275 12.3823 23.1744 12.917 22.5 12.9167C22.2803 12.9166 22.0646 12.8581 21.875 12.7471C21.5833 12.5774 21.3722 12.2975 21.2892 11.9704C21.262 11.8715 21.2488 11.7693 21.25 11.6667C21.25 11.6514 21.2492 11.636 21.2475 11.6208L20.8821 8.33333H23ZM19.1667 15.8333H15C14.7699 15.8333 14.5833 16.0199 14.5833 16.25V22.5H3.75V13.3183C3.90755 13.202 4.04781 13.064 4.16667 12.9083C4.84625 13.8288 6.14333 14.0241 7.0638 13.3445C7.23016 13.2217 7.37719 13.0747 7.5 12.9083C8.17958 13.8288 9.47667 14.0241 10.3971 13.3445C10.5635 13.2217 10.7105 13.0747 10.8333 12.9083C11.5129 13.8288 12.81 14.0241 13.7305 13.3445C13.8968 13.2217 14.0439 13.0747 14.1667 12.9083C14.8462 13.8288 16.1433 14.0241 17.0638 13.3445C17.2302 13.2217 17.3772 13.0747 17.5 12.9083C18.1799 13.8288 19.4773 14.0238 20.3978 13.3439C20.5639 13.2212 20.7107 13.0744 20.8333 12.9083C20.9521 13.0636 21.0924 13.2013 21.25 13.3171V22.5H19.5833V16.25C19.5833 16.0199 19.3968 15.8333 19.1667 15.8333ZM18.75 16.6667V22.5H15.4167V16.6667H18.75ZM4.58333 11.6883L4.95833 8.33333H7.45333L7.08792 11.6208C7.08552 11.636 7.08401 11.6513 7.08333 11.6667C7.08432 11.7727 7.07026 11.8783 7.04167 11.9804C6.86568 12.648 6.18187 13.0465 5.51432 12.8705C5.07542 12.7548 4.73375 12.4103 4.62167 11.9704C4.59651 11.8785 4.58365 11.7836 4.58333 11.6883ZM7.91667 11.6883L8.29167 8.33333H10.4167V11.6667C10.4177 11.7727 10.4036 11.8783 10.375 11.9804C10.199 12.648 9.51521 13.0465 8.84766 12.8705C8.40875 12.7548 8.06708 12.4103 7.955 11.9704C7.92984 11.8785 7.91698 11.7836 7.91667 11.6883ZM11.25 11.6667V8.33333H13.75V11.6667C13.751 11.7727 13.7369 11.8783 13.7083 11.9804C13.5323 12.648 12.8485 13.0465 12.181 12.8705C11.7421 12.7548 11.4004 12.4103 11.2883 11.9704C11.2614 11.8715 11.2485 11.7692 11.25 11.6667ZM14.5833 11.6667V8.33333H16.7083L17.0833 11.6883C17.0822 11.787 17.0682 11.885 17.0417 11.98C16.8657 12.6476 16.1819 13.046 15.5143 12.8701C15.0754 12.7544 14.7337 12.4098 14.6217 11.97C14.5948 11.8712 14.5819 11.7691 14.5833 11.6667ZM17.5487 8.33333H20.0437L20.4188 11.6883C20.4177 11.787 20.4036 11.885 20.3771 11.98C20.2011 12.6476 19.5173 13.046 18.8497 12.8701C18.4108 12.7544 18.0692 12.4098 17.9571 11.97C17.9295 11.8713 17.9159 11.7692 17.9167 11.6667C17.9167 11.6514 17.9158 11.636 17.9142 11.6208L17.5487 8.33333ZM6.25 4.16667V0.833333H18.75V4.16667H6.25ZM17.5 5V5.83333H7.5V5H17.5ZM3.75 6.66667H21.25V7.5H3.75V6.66667ZM2.5 12.9167C1.82557 12.917 1.2725 12.3823 1.25 11.7083L2 8.33333H4.11708L3.75167 11.6208C3.75026 11.6361 3.74974 11.6514 3.75 11.6667C3.75083 11.7724 3.73677 11.8778 3.70833 11.9796C3.62432 12.3031 3.41422 12.5795 3.125 12.7471C2.93542 12.8581 2.71969 12.9166 2.5 12.9167ZM24.1667 24.1667H0.833333V23.3333H24.1667V24.1667Z" />
                          <path d="M12.5001 15.8335H5.83341C5.60331 15.8335 5.41675 16.0201 5.41675 16.2502V20.4168C5.41675 20.6469 5.60331 20.8335 5.83341 20.8335H12.5001C12.7302 20.8335 12.9167 20.6469 12.9167 20.4168V16.2502C12.9167 16.0201 12.7302 15.8335 12.5001 15.8335ZM12.0834 20.0002H6.25008V16.6668H12.0834V20.0002Z" />
                        </svg>
                        <p className="poppins mb-0 ">Pages</p>
                      </Link>
                    </li>
                    <li className="btn btn-lg">
                      <Link
                        to="/article/all-article"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <SvgArticle />
                        <p className="poppins mb-0">Articles</p>
                      </Link>
                    </li>
                    <li className="btn btn-lg">
                      <Link
                        to="/groups"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <SvgGroup />
                        <p className="poppins mb-0">Groups </p>
                      </Link>
                    </li>
                    <li className="btn btn-lg">
                      <Link
                        to="/adorders"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <SvgEvent />
                        <p className="poppins mb-0 ">My Paid Ads</p>
                      </Link>
                    </li>
                    <li className="btn btn-lg">
                      <Link
                        to="/adcart"
                        className="p-0"
                        onChange={() => this.borderTop("myli6")}
                      >
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="#999999"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M10.2519 6.41444V9.16483C10.2519 10.6816 11.485 11.9156 13.0006 11.9156H17.9992C19.5148 11.9156 20.7479 10.6816 20.7479 9.16483V6.38354C20.911 6.4913 21.0979 6.54566 21.2846 6.54566C21.5509 6.54566 21.8162 6.43733 22.0088 6.22428C22.3707 5.82449 22.34 5.20709 21.9402 4.84526L17.3902 0.727297C16.3259 -0.243734 14.7228 -0.243734 13.6587 0.727297L9.10849 4.84526C8.70871 5.20709 8.678 5.82449 9.03982 6.22428C9.35435 6.57179 9.86189 6.64027 10.2519 6.41444ZM14.9703 2.17383C14.9715 2.17269 14.9728 2.17154 14.974 2.17059C15.2877 1.88372 15.7609 1.88372 16.0747 2.17059C16.0758 2.17154 16.077 2.17269 16.0783 2.17383L18.8005 4.63755C18.7971 4.67093 18.7951 4.70488 18.7951 4.73921V9.16483C18.7951 9.60486 18.4381 9.96287 17.9992 9.96287H13.0006C12.5617 9.96287 12.2047 9.60486 12.2047 9.16483V4.73921C12.2047 4.71919 12.2028 4.69935 12.2016 4.67951L14.9703 2.17383ZM23.0424 19.1408V18.1214C23.0424 16.8801 22.0323 15.8699 20.7906 15.8699H11.4234C10.8852 15.8699 10.4471 16.308 10.4471 16.8463C10.4471 17.0777 10.5285 17.2903 10.6636 17.4578L10.8617 17.639C10.8676 17.6443 10.8728 17.6504 10.8787 17.6562C11.0345 17.7613 11.222 17.8227 11.4234 17.8227H16.3055C16.8447 17.8227 17.2819 18.2598 17.2819 18.799C17.2819 19.3382 16.8447 19.7754 16.3055 19.7754H11.4234C10.5747 19.7754 9.80944 19.4123 9.27386 18.8334L3.63821 13.6837C3.62963 13.6757 3.62124 13.6679 3.61284 13.6597C3.42669 13.477 3.17988 13.3782 2.91991 13.3803C2.65917 13.3826 2.41484 13.4865 2.23231 13.6727C2.04958 13.8588 1.95021 14.1051 1.95269 14.3658C1.95517 14.6225 2.05588 14.8632 2.23669 15.045L7.20496 19.645C7.2103 19.6499 7.21564 19.6551 7.22079 19.66C9.47623 21.8437 12.4473 23.0463 15.5866 23.0463H24.0188C24.558 23.0463 24.9952 23.4835 24.9952 24.0227C24.9952 24.5619 24.558 24.9991 24.0188 24.9991H15.5866C13.7805 24.9991 12.0157 24.6554 10.3414 23.9777C8.67056 23.3013 7.16643 22.3232 5.87057 21.0707L0.897925 16.4667C0.891059 16.4603 0.884192 16.4538 0.877326 16.4473C0.319045 15.8991 0.00738403 15.1665 0.000136088 14.3841C-0.0073026 13.6017 0.290435 12.8634 0.838416 12.3049C1.3864 11.7466 2.1192 11.435 2.90159 11.4275C3.67579 11.4205 4.41031 11.7131 4.96706 12.2526L8.7316 15.6925C9.1804 14.6496 10.218 13.9172 11.4234 13.9172H20.7906C23.109 13.9172 24.9952 15.8034 24.9952 18.1216V19.1408C24.9952 19.68 24.558 20.1172 24.0188 20.1172C23.4796 20.1172 23.0424 19.68 23.0424 19.1408Z" />
                        </svg>
                        <p className="poppins mb-0 ">Ad Cart</p>
                      </Link>
                    </li>
                    {/*
                    <li className="btn btn-lg">
                      <Link
                        to="/services"
                        className="p-0"
                        // onChange={() => this.borderTop("myli6")}
                      >
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="#999999"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0)">
                            <path d="M24.218 12.3334C23.3821 11.6445 22.0609 11.5854 21.1938 12.5161L19.0411 14.8269C18.7627 13.9325 17.9273 13.2811 16.9426 13.2811H13.101C12.8095 13.2811 12.7119 13.1698 12.2056 12.7797C10.275 11.0967 7.37529 11.1021 5.45059 12.7958L4.03857 14.0389C3.40386 13.703 2.6627 13.6947 2.02451 14.0135L0.404981 14.823C0.0431644 15.0042 -0.103271 15.4441 0.0773441 15.8059L4.47163 24.5944C4.65278 24.9562 5.09268 25.1027 5.45449 24.9221L7.07402 24.112C7.87231 23.7132 8.3166 22.8987 8.28779 22.0697H16.9425C18.5474 22.0697 20.081 21.3032 21.0438 20.0191L24.5598 15.3309C25.2418 14.4222 25.1339 13.0897 24.218 12.3334ZM6.41875 22.802L5.45444 23.2844L1.71494 15.8059L2.67974 15.3235C3.04155 15.1429 3.48096 15.2889 3.66211 15.6512L6.74639 21.8197C6.92705 22.1815 6.78057 22.6209 6.41875 22.802ZM23.3879 14.452L19.8721 19.1402C19.1841 20.0576 18.089 20.6049 16.9426 20.6049H7.77661L5.03213 15.1155L6.41826 13.8954C7.79756 12.6821 9.87754 12.6821 11.2568 13.8954C12.0693 14.6107 12.5746 14.7459 13.101 14.7459H16.9425C17.3463 14.7459 17.6749 15.0745 17.6749 15.4783C17.6749 15.8821 17.3463 16.2107 16.9425 16.2107H13.2021C12.7978 16.2107 12.4697 16.5388 12.4697 16.9431C12.4697 17.3473 12.7978 17.6754 13.2021 17.6754H17.4333C18.0411 17.6754 18.6271 17.4205 19.0411 16.9758L22.2655 13.5145C22.5604 13.1981 23.0125 13.2245 23.2898 13.4672C23.5798 13.721 23.6111 14.1551 23.3879 14.452Z" />
                            <path d="M15.3997 4.99824C15.9011 4.47241 16.2102 3.76152 16.2102 2.97881C16.2102 1.3666 14.9076 0.000488281 13.2807 0.000488281C11.6661 0.000488281 10.3024 1.36416 10.3024 2.97881C10.3024 3.73755 10.5998 4.45381 11.1397 5.0041C9.80049 5.75503 8.83765 7.19634 8.83765 8.88667V9.61904C8.83765 10.0233 9.16577 10.3514 9.57002 10.3514H16.9426C17.3469 10.3514 17.675 10.0233 17.675 9.61904V8.88667C17.6749 7.22954 16.7635 5.76577 15.3997 4.99824ZM13.2807 1.46528C14.0746 1.46528 14.7454 2.15859 14.7454 2.97886C14.7454 3.78643 14.0883 4.4436 13.2807 4.4436C12.4604 4.4436 11.7671 3.77275 11.7671 2.97886C11.7671 2.17275 12.4746 1.46528 13.2807 1.46528ZM10.3024 8.88667C10.3024 7.27202 11.6661 5.90835 13.2807 5.90835C14.8958 5.90835 16.2102 7.24419 16.2102 8.88667H10.3024Z" />
                          </g>
                          <defs>
                            <clipPath id="clip0">
                              <rect width="25" height="25" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <p className="poppins mb-0 ">Services</p>
                      </Link>
                    </li>*/}
                    <li>
                      <Link className="blend" to="/my-profile">
                        <i className="fa fa-user"></i>
                        &nbsp;&nbsp;&nbsp;&nbsp;My profile
                      </Link>
                    </li>
                    <li>
                      <Link className="blend" to="/settings/privacy-login">
                        <i className="fas fa-cog"></i>
                        &nbsp;&nbsp;&nbsp;&nbsp;Settings
                      </Link>
                    </li>
                    <li
                      className="btn btn-lg text-dark"
                      onClick={() => this.logout()}
                    >
                      <FaPowerOff />
                      <p className="poppins mb-0 text-capitalize">Log Out</p>
                    </li>
                  </ul>
                </Card>
              </div>
            ) : (
              ""
            )}
          </div>

          {this.state.isNotUser ? (
            <div>
              <Link to="/home">
                <h1
                  className="mt-3 mb-0 text-center logo-title"
                  style={{
                    fontSize: "3em",
                    color: "black",
                  }}
                >
                  Fonolive
                </h1>
              </Link>
            </div>
          ) : (
            <div className="d-flex row mx-0">
              <div
                className="header-logo"
                style={{ display: "grid", placeItems: "center" }}
              >
                <Link to="/home">
                  <h5 className="display-5 m-0 text-dark logo-title">
                    Fonolive
                  </h5>
                </Link>
              </div>
              <div className="col-md-5 col-sm-9"></div>
              <div className="col-md-4 col-sm-12 d-flex align-items-center">
                <FormGroup className="w-100">
                  {/*  <InputGroup className="mt-3">
                    <Input
                      placeholder="are you in search of something"
                      className="myborder"
                      type="text"
                    /> 
                    <InputGroupAddon addonType="append">
                      <InputGroupText className="myborder1">
                        <i className="fa fa-search mr-2" />
                      </InputGroupText>
                    </InputGroupAddon>
          </InputGroup> */}
                </FormGroup>

                <div className="notify-dropdown ml-4">
                  <div
                    className="dropbtn"
                    onClick={() => {
                      this.dropownToggle();
                      this.fetchNotification();
                      this.readAllNotifications();
                    }}
                  >
                    <svg
                      width="20"
                      height="27"
                      viewBox="0 0 20 27"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M11.3187 1.3187C11.3187 0.59041 10.7283 0 9.99999 0C9.27167 0 8.68129 0.59041 8.68129 1.3187V2.30773H7.94624C5.012 2.30773 2.58348 4.5891 2.40032 7.51759L2.10888 12.1772C1.99776 13.9537 1.40133 15.6658 0.384526 17.1268C-0.534189 18.4468 0.283698 20.2701 1.88056 20.4617L6.37355 21.0009V22.418C6.37355 24.4208 7.99714 26.0444 9.99999 26.0444C12.0028 26.0444 13.6264 24.4208 13.6264 22.418V21.0009L18.1194 20.4617C19.7163 20.2701 20.5342 18.4468 19.6155 17.1268C18.5986 15.6658 18.0022 13.9537 17.8911 12.1772L17.5997 7.51759C17.4165 4.5891 14.988 2.30773 12.0537 2.30773H11.3187V1.3187ZM8.35136 22.418C8.35136 23.3284 9.08931 24.0664 9.99974 24.0664C10.9102 24.0664 11.6481 23.3284 11.6481 22.418V21.4289H8.35136V22.418Z"
                        fill="#787885"
                      />
                    </svg>
                    {this.state.allNotifications.length > 0 && (
                      <span
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          background: "#EB5757",
                          color: "#fff",
                          width: "16px",
                          height: "16px",
                          display: "grid",
                          placeItems: "center",
                          borderRadius: "50%",
                          fontSize: "11px",
                        }}
                      >
                        {this.state.allNotifications.length}
                      </span>
                    )}
                  </div>

                  {this.state.notificationToggle && (
                    <div className="noti-dropDown" ref={this.notiDropDownRef}>
                      <div className="notification-arrow"></div>
                      {console.log(this.state.allNotifications)}
                      {Array.isArray(this.state.allNotifications) &&
                      this.state.allNotifications.length === 0 ? (
                        <p className="text-dark text-center">
                          No Notifications
                        </p>
                      ) : (
                        this.state.allNotifications.map((item) => {
                          return (
                            <React.Fragment key={item.createdAt}>
                              <div className="position-relative">
                                <div className="p-1 text-end">
                                  <p className="notiTime">
                                    {format(item.createdAt)}
                                  </p>
                                  <li
                                    className="list-group-item border-none"
                                    style={{ border: "none" }}
                                  >
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="d-flex align-items-center">
                                        <div className="p-1">
                                          {console.log(item)}
                                          {item.user.image ? (
                                            <Link
                                              to={`/user-profile/${item.senderId}`}
                                            >
                                              <img
                                                width="50px"
                                                height="50px"
                                                style={{
                                                  objectFit: "cover",
                                                  borderRadius: "50%",
                                                }}
                                                src={item.user.image}
                                                alt=""
                                              />
                                            </Link>
                                          ) : (
                                            <Link
                                              to={`/user-profile/${item.senderId}`}
                                            >
                                              <Avatar
                                                size="50"
                                                round={true}
                                                name={item.user.firstname}
                                              />
                                            </Link>
                                          )}
                                        </div>
                                        <div className="p-2">
                                          <p className="notiContent">
                                            {item.user.firstname +
                                              " " +
                                              item.user.lastname}{" "}
                                            {item.notification}
                                            {item.notify_type === "request" && (
                                              <Link
                                                to={`/user-profile/${item.senderId}`}
                                              >
                                                {". Like " +
                                                  item.user.firstname +
                                                  "'s posts?"}
                                              </Link>
                                            )}
                                            {item.notify_type ===
                                              "chat-message" && (
                                              <Link
                                                to={`/user-chat/${item.senderId}`}
                                              >
                                                {". View " +
                                                  item.user.firstname +
                                                  "'s message?"}
                                              </Link>
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                      {item.notify_type === "request" && (
                                        <div className="d-flex flex-row justify-content-end">
                                          <span
                                            className="noti-Btn btnAccept"
                                            onClick={() => {
                                              this.addFollower(
                                                item.senderId,
                                                "Accept"
                                              );
                                              this.readNotification(item._id);
                                            }}
                                          >
                                            Follow
                                          </span>
                                          <span
                                            className="noti-Btn btnReject"
                                            onClick={() => {
                                              this.addFollower(
                                                item.senderId,
                                                "Reject"
                                              );
                                              this.readNotification(item._id);
                                            }}
                                          >
                                            Reject
                                          </span>
                                        </div>
                                      )}
                                    </div>
                                  </li>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="mt-3 d-lg-flex d-none">
            {this.state.isNotUser ? (
              <div className="header-user"></div>
            ) : (
              <div className="header-user position-relative">
                <div
                  className="drop-color h-10 curPointer"
                  style={{ borderRadius: "12px" }}
                  onClick={() =>
                    this.setState((prev) => ({
                      ...prev,
                      profileDropDown: !this.state.profileDropDown,
                    }))
                  }
                >
                  <div className="d-flex flex-row align-items-center profileContainer">
                    <div className="ml-3">
                      <div className="icon-container">
                        {this.state.userData.image ? (
                          <img
                            width="48px"
                            height="48px"
                            src={this.state.userData.image}
                            style={{ borderRadius: "50%", objectFit: "cover" }}
                            alt=""
                          />
                        ) : (
                          <Avatar
                            round={true}
                            size="50"
                            name={
                              this.state.userData.firstname
                                ? this.state.userData.firstname
                                : "⌛"
                            }
                            maxInitials={2}
                            alt=""
                          />
                        )}
                        {this.isOnline ? (
                          <div className="status"></div>
                        ) : (
                          <div className="status"></div>
                        )}
                      </div>
                    </div>
                    <div className="pl-2">
                      <h6
                        className="poppins text-color text-left text-capitalize mb-0"
                        style={{
                          fontSize: "14px",
                          fontWeight: "bold",
                          color: "#545AF2",
                        }}
                      >
                        {this.state.userData.firstname ? (
                          `${this.state.userData.firstname} ${this.state.userData.lastname}`
                        ) : (
                          <span className="text-dark">Loading...</span>
                        )}
                        {/* {this.state.userData.firstname +
                          " " +
                          this.state.userData.lastname} */}
                      </h6>
                      <p
                        className="lead text-muted mb-0 mt-1"
                        style={{ fontSize: "12px", color: "#8D8D8D" }}
                      >
                        @{this.state.userData.username}
                      </p>
                    </div>
                  </div>
                </div>
                {this.state.isNotUser
                  ? ""
                  : this.state.profileDropDown && (
                      <div
                        className="profileDropDown"
                        ref={this.userDropDownRef}
                      >
                        <Link to="/my-profile">
                          <i className="fa fa-user"></i>
                          &nbsp;&nbsp;&nbsp;&nbsp;My profile
                        </Link>

                        <Link to="/settings/privacy-login">
                          <i className="fas fa-cog"></i>
                          &nbsp;&nbsp;&nbsp;&nbsp;Settings
                        </Link>
                        <li
                          className="pb-3"
                          href="#pablo"
                          onClick={(e) => {
                            e.preventDefault();
                            this.logout();
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            className="powerIcon"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10.0002 0C4.47708 0 0.000244141 4.47743 0.000244141 10.0005C0.000244141 15.5237 4.47708 20 10.0002 20C15.5234 20 20 15.5237 20 10.0005C20 4.47743 15.5234 0 10.0002 0ZM9.12336 2.09097C9.12336 1.60649 9.51618 1.21327 10.0012 1.21327C10.4857 1.21327 10.8788 1.60649 10.8788 2.09097V9.6915C10.8788 10.1757 10.4857 10.5688 10.0012 10.5688C9.51618 10.5688 9.12336 10.1757 9.12336 9.6915V2.09097ZM10.0002 18.2408C5.65716 18.2408 2.12408 14.7079 2.12408 10.364C2.12408 6.66568 4.69063 3.56225 8.13419 2.7207V4.22754C5.50419 5.02864 3.58468 7.47568 3.58468 10.364C3.58468 13.9015 6.46301 16.7792 9.99992 16.7792C13.5377 16.7792 16.4148 13.9009 16.4148 10.364C16.4148 7.47568 14.4954 5.02864 11.8656 4.22754V2.72075C15.3096 3.5623 17.8764 6.66513 17.8764 10.364C17.8764 14.7079 14.3431 18.2408 10.0002 18.2408Z" />
                          </svg>
                          &nbsp;&nbsp;&nbsp;&nbsp;Logout
                        </li>
                      </div>
                    )}
              </div>
            )}
            <div className="header-main">
              <Card
                className="list-inline main-menu bg bg-white nav nav-tabs d-flex justify-content-around border-0"
                id="myTab"
                role="tablist"
              >
                <li
                  className={`myli1 text-center ${
                    window.location.pathname === "/home" && "borderActive"
                  }`}
                  role="presentation"
                >
                  <Link
                    to="/home"
                    className="btn btn-lg mr-0 active"
                    onChange={() => this.borderTop("myli1")}
                  >
                    <SvgFeed />
                  </Link>
                  <Link to="/home">
                    <p
                      className={`menu-text ${
                        window.location.pathname === "/home" &&
                        "textActive font-weight-bold"
                      }`}
                    >
                      Feed
                    </p>
                  </Link>
                </li>

                <li
                  className={`myli1 text-center ${
                    window.location.pathname === "/connect" && "borderActive"
                  }`}
                  role="presentation"
                >
                  <Link
                    to="/connect"
                    className="btn btn-lg mr-0"
                    onChange={() => this.borderTop("myli6")}
                  >
                    <SvgMyNetWork />
                  </Link>
                  <Link to="/connect">
                    <p
                      className={`menu-text ${
                        window.location.pathname === "/connect" &&
                        "textActive font-weight-bold"
                      }`}
                    >
                      Network
                    </p>
                  </Link>
                </li>

                <li
                  className={`myli1 text-center ${
                    window.location.pathname === "/marketplace" ||
                    window.location.pathname === "/subscriptions" ||
                    window.location.pathname === "/cart" ||
                    window.location.pathname === "/classifieds" ||
                    window.location.pathname === "/rentals" ||
                    window.location.pathname === "/orders" ||
                    window.location.pathname === "/wishlist"
                      ? "borderActive"
                      : ""
                  }`}
                  role="presentation"
                >
                  <Link
                    to="/marketplace"
                    className="btn btn-lg mr-0"
                    onChange={() => this.borderTop("myli3")}
                  >
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0.612671 0V18.9862C0.612671 20.275 1.6612 21.3235 2.94998 21.3235H8.70091V23.5294H5.75973V25H19.0044V23.5294H16.0538V21.3235H22.0499C23.3387 21.3235 24.3872 20.275 24.3872 18.9862V0H0.612671ZM18.0146 1.47059H19.7303V6.98529C19.7303 7.45828 19.3455 7.84313 18.8725 7.84313C18.3995 7.84313 18.0146 7.45828 18.0146 6.98529V1.47059ZM14.8284 1.47059H16.544V6.98529C16.544 7.45828 16.1592 7.84313 15.6862 7.84313C15.2132 7.84313 14.8284 7.45828 14.8284 6.98529V1.47059ZM11.6389 1.47059H13.3546V6.98529C13.3546 7.45828 12.9698 7.84313 12.4968 7.84313C12.0238 7.84313 11.6389 7.45828 11.6389 6.98529V1.47059ZM5.26953 9.14926C5.53522 9.25494 5.82449 9.31372 6.12738 9.31372C6.74248 9.31372 7.30228 9.07352 7.71895 8.68254C8.13561 9.07352 8.69542 9.31372 9.31052 9.31372C9.61458 9.31372 9.90498 9.2545 10.1715 9.14803V12.5H5.26953V9.14926ZM10.1684 1.47059V6.98529C10.1684 7.45828 9.78351 7.84313 9.31052 7.84313C8.85145 7.84313 8.4765 7.48034 8.45478 7.02651C8.45502 7.01274 8.45581 6.99911 8.45581 6.98529V1.47059H10.1684ZM5.26953 1.47059H6.98208V6.98529C6.98208 6.99911 6.98287 7.01274 6.98311 7.02651C6.9614 7.48034 6.58645 7.84313 6.12738 7.84313C5.65439 7.84313 5.26953 7.45828 5.26953 6.98529V1.47059ZM2.08326 1.47059H3.79895V6.98529C3.79895 7.45828 3.41409 7.84313 2.9411 7.84313C2.46811 7.84313 2.08326 7.45828 2.08326 6.98529V1.47059ZM14.5833 23.5294H10.1715V21.3235H14.5833V23.5294ZM22.9166 18.9862C22.9166 19.4641 22.5278 19.8529 22.0499 19.8529H2.94998C2.47208 19.8529 2.08326 19.4641 2.08326 18.9862V18.3823H14.3382H20.9558H22.9166V18.9862ZM19.4852 16.9118H15.8088V12.2549H19.4852V16.9118ZM20.9558 16.9118V10.7843H14.3382V16.9118H2.08326V9.14926C2.34895 9.25494 2.63821 9.31372 2.9411 9.31372C3.24399 9.31372 3.53326 9.25494 3.79895 9.14926V13.9706H11.6421V9.15048C11.9069 9.25539 12.1951 9.31372 12.4968 9.31372C13.1135 9.31372 13.6745 9.0723 14.0915 8.67955C14.5085 9.0723 15.0695 9.31372 15.6862 9.31372C16.3021 9.31372 16.8625 9.07289 17.2793 8.68107C17.6962 9.07289 18.2566 9.31372 18.8725 9.31372C19.4884 9.31372 20.0488 9.07289 20.4656 8.68107C20.8825 9.07289 21.4429 9.31372 22.0588 9.31372C22.3616 9.31372 22.6509 9.25494 22.9166 9.14926V16.9118H20.9558ZM22.9166 6.98529C22.9166 7.45828 22.5317 7.84313 22.0588 7.84313C21.5858 7.84313 21.2009 7.45828 21.2009 6.98529V1.47059H22.9166V5.39215V6.98529Z" />
                    </svg>
                  </Link>
                  <Link to="/marketplace">
                    <p
                      className={`menu-text ${
                        (window.location.pathname === "/marketplace" ||
                          window.location.pathname === "/subscriptions" ||
                          window.location.pathname === "/cart" ||
                          window.location.pathname === "/classifieds" ||
                          window.location.pathname === "/rentals" ||
                          window.location.pathname === "/orders" ||
                          window.location.pathname === "/wishlist") &&
                        "textActive font-weight-bold"
                      }`}
                    >
                      Marketplaces
                    </p>
                  </Link>
                </li>

                <li
                  className={`myli1 text-center ${
                    (window.location.pathname === "/jobs" ||
                      window.location.pathname === "/jobs/recommended-job" ||
                      window.location.pathname === "/jobs/my-jobs" ||
                      window.location.pathname === "/job/create-job") &&
                    "borderActive"
                  }`}
                  role="presentation"
                >
                  <Link
                    to="/jobs"
                    className="btn btn-lg mr-0 myli4"
                    onChange={() => this.borderTop("myli4")}
                  >
                    <svg
                      width="25"
                      height="23"
                      viewBox="0 0 25 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M24.2722 3.17988C24.2706 3.17988 24.2691 3.17969 24.2676 3.17969H17.627V2.44727C17.627 1.23572 16.6412 0.25 15.4297 0.25H9.57031C8.35876 0.25 7.37305 1.23572 7.37305 2.44727V3.17969H0.732422C0.324631 3.17969 0 3.51385 0 3.91211V20.0254C0 21.2369 0.985718 22.2227 2.19727 22.2227H22.8027C24.0143 22.2227 25 21.2369 25 20.0254V3.92756C25 3.92661 25 3.92565 25 3.9247C24.972 3.44366 24.6761 3.18255 24.2722 3.17988ZM8.83789 2.44727C8.83789 2.04348 9.16653 1.71484 9.57031 1.71484H15.4297C15.8335 1.71484 16.1621 2.04348 16.1621 2.44727V3.17969H8.83789V2.44727ZM23.2513 4.64453L20.9768 11.4679C20.8771 11.7675 20.5978 11.9688 20.2822 11.9688H16.1621V11.2363C16.1621 10.8318 15.8342 10.5039 15.4297 10.5039H9.57031C9.16576 10.5039 8.83789 10.8318 8.83789 11.2363V11.9688H4.71783C4.40216 11.9688 4.12292 11.7675 4.02317 11.4679L1.74866 4.64453H23.2513ZM14.6973 11.9688V13.4336H10.3027V11.9688H14.6973ZM23.5352 20.0254C23.5352 20.4292 23.2065 20.7578 22.8027 20.7578H2.19727C1.79348 20.7578 1.46484 20.4292 1.46484 20.0254V8.42547L2.63348 11.9312C2.93293 12.8299 3.77064 13.4336 4.71783 13.4336H8.83789V14.166C8.83789 14.5706 9.16576 14.8984 9.57031 14.8984H15.4297C15.8342 14.8984 16.1621 14.5706 16.1621 14.166V13.4336H20.2822C21.2294 13.4336 22.0671 12.8299 22.3665 11.9312L23.5352 8.42547V20.0254Z" />
                    </svg>
                  </Link>
                  <Link to="/jobs">
                    <p
                      className={`menu-text ${
                        (window.location.pathname === "/jobs" ||
                          window.location.pathname ===
                            "/jobs/recommended-job" ||
                          window.location.pathname === "/jobs/my-jobs" ||
                          window.location.pathname === "/job/create-job") &&
                        "textActive font-weight-bold"
                      }`}
                    >
                      Jobs
                    </p>
                  </Link>
                </li>

                <li
                  className={`myli1 text-center ${
                    window.location.pathname === "/events" ||
                    window.location.pathname === "/events/createEvent"
                      ? "borderActive"
                      : ""
                  }`}
                  role="presentation"
                >
                  <Link
                    to="/pages"
                    className="btn btn-lg mr-0"
                    onChange={() => this.borderTop("myli5")}
                  >
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M11.4091 17.4567C11.5475 17.5949 11.7352 17.6728 11.9311 17.6728C12.1268 17.6728 12.3145 17.5951 12.453 17.4567L15.0883 14.8213C15.3767 14.5329 15.3767 14.0656 15.0883 13.7772C14.8001 13.489 14.3326 13.489 14.0444 13.7772L11.9311 15.8905L10.9675 14.9269C10.6791 14.6387 10.2118 14.6387 9.92343 14.9269C9.63523 15.2151 9.63523 15.6826 9.92343 15.971L11.4091 17.4567Z" />
                      <path d="M12.5059 21.4769C15.7371 21.4769 18.3658 18.848 18.3658 15.6168C18.3658 12.3855 15.7371 9.75684 12.5059 9.75684C9.27446 9.75684 6.64575 12.3855 6.64575 15.6168C6.64575 18.848 9.27465 21.4769 12.5059 21.4769ZM12.5059 11.2331C14.9231 11.2331 16.8895 13.1996 16.8895 15.6168C16.8895 18.034 14.9231 20.0006 12.5059 20.0006C10.0887 20.0006 8.12204 18.034 8.12204 15.6168C8.12204 13.1996 10.0887 11.2331 12.5059 11.2331Z" />
                      <path d="M22.3312 1.57185H20.9848V0.738144C20.9848 0.330544 20.6543 0 20.2467 0C19.8391 0 19.5086 0.330544 19.5086 0.738144V1.57185H18.058V0.738144C18.058 0.330544 17.7275 0 17.3197 0C16.9121 0 16.5815 0.330544 16.5815 0.738144V1.57185H8.43029V0.738144C8.43029 0.330544 8.09975 0 7.69196 0C7.28436 0 6.95381 0.330544 6.95381 0.738144V1.57185H5.50327V0.738144C5.50327 0.330544 5.17273 0 4.76494 0C4.35734 0 4.02679 0.330544 4.02679 0.738144V1.57185H2.68021C1.36395 1.57185 0.292969 2.64282 0.292969 3.95927V22.6128C0.292969 23.929 1.36395 25 2.68021 25H22.3312C23.6477 25 24.7185 23.929 24.7185 22.6128V3.95927C24.7185 2.64282 23.6475 1.57185 22.3312 1.57185ZM23.242 22.6128C23.242 23.115 22.8334 23.5237 22.3312 23.5237H2.68021C2.178 23.5237 1.76926 23.115 1.76926 22.6128V7.70988H23.242V22.6128ZM1.76926 3.95927C1.76926 3.45688 2.178 3.04832 2.68021 3.04832H4.02679V3.88203C4.02679 4.28963 4.35734 4.62017 4.76513 4.62017C5.17273 4.62017 5.50327 4.28963 5.50327 3.88203V3.04832H6.95381V3.88203C6.95381 4.28963 7.28436 4.62017 7.69215 4.62017C8.09975 4.62017 8.43029 4.28963 8.43029 3.88203V3.04832H16.5815V3.88203C16.5815 4.28963 16.9121 4.62017 17.3199 4.62017C17.7275 4.62017 18.058 4.28963 18.058 3.88203V3.04832H19.5086V3.88203C19.5086 4.28963 19.8391 4.62017 20.2467 4.62017C20.6545 4.62017 20.985 4.28963 20.985 3.88203V3.04832H22.3312C22.8334 3.04832 23.2422 3.45688 23.2422 3.95927V6.23341H1.76926V3.95927Z" />
                    </svg>
                  </Link>
                  <Link to="/pages">
                    <p
                      className={`menu-text ${
                        window.location.pathname === "/pages" ||
                        window.location.pathname === "/pages/create-page"
                          ? "textActive font-weight-bold"
                          : ""
                      }`}
                    >
                      Pages
                    </p>
                  </Link>
                </li>
                {/*<li
                  className={`myli1 text-center ${
                    window.location.pathname === "/dating" && "borderActive"
                  }`}
                  role="presentation"
                >
                  <Link
                    to="/dating"
                    className="btn btn-lg mr-0"
                    onChange={() => this.borderTop("myli2")}
                  >
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M21.5635 17.6368C22.5635 16.8466 23.2064 15.6235 23.2064 14.253C23.2064 11.8759 21.2725 9.94198 18.8953 9.94198C16.5183 9.94198 14.5844 11.8759 14.5844 14.253C14.5844 15.6234 15.2272 16.8466 16.2272 17.6368C15.0148 18.1596 14.0269 19.0271 13.4278 20.0938C12.7849 18.5615 11.4623 17.317 9.78388 16.6456C10.9996 15.7611 11.7915 14.3278 11.7915 12.7127C11.7915 10.0322 9.61079 7.85156 6.93038 7.85156C4.24997 7.85156 2.06926 10.0322 2.06926 12.7127C2.06926 14.3278 2.86117 15.7611 4.07689 16.6456C1.67844 17.605 0.00634766 19.7349 0.00634766 22.2022V25.0004H24.9943V22.4772C24.9942 20.3528 23.5929 18.512 21.5635 17.6368ZM3.53974 12.7127C3.53974 10.8431 5.06075 9.32213 6.93029 9.32213C8.79982 9.32213 10.3208 10.8431 10.3208 12.7127C10.3208 14.5823 8.79982 16.1033 6.93029 16.1033C5.06075 16.1033 3.53974 14.5822 3.53974 12.7127ZM12.3838 23.5298H1.47682V22.2021C1.47682 19.6501 3.92326 17.5738 6.93033 17.5738C9.93741 17.5738 12.3838 19.6501 12.3838 22.2021V23.5298ZM16.0549 14.253C16.0549 12.6868 17.3291 11.4126 18.8953 11.4126C20.4615 11.4126 21.7357 12.6868 21.7357 14.253C21.7357 15.8192 20.4615 17.0934 18.8953 17.0934C17.3291 17.0935 16.0549 15.8193 16.0549 14.253ZM23.5236 23.5298H14.267V22.4772C14.267 20.3194 16.3432 18.564 18.8953 18.564C21.4474 18.564 23.5236 20.3195 23.5236 22.4772V23.5298Z" />
                      <path d="M12.5062 8.36812L16.033 4.85806C17.1424 3.74857 17.1424 1.94334 16.033 0.833944C15.0569 -0.142123 13.577 -0.244426 12.4987 0.440762C11.4207 -0.244181 9.94073 -0.142466 8.96442 0.833944C7.8563 1.94202 7.84763 3.74121 8.96678 4.86042L12.5062 8.36812ZM10.0043 1.87374C10.5411 1.33688 11.4117 1.33673 11.9487 1.87374L12.4987 2.42373L13.0487 1.87374C13.5854 1.33693 14.4561 1.33673 14.9931 1.87374C15.5292 2.40981 15.5292 3.28205 14.9943 3.81695L12.504 6.2955L10.0043 3.81817C9.46701 3.28102 9.46692 2.41108 10.0043 1.87374Z" />
                    </svg>
                  </Link>
                  <Link to="/dating">
                    <p
                      className={`menu-text ${
                        window.location.pathname === "/dating" && "textActive"
                      }`}
                    >
                      Meetup
                    </p>
                  </Link>
                </li> */}
              </Card>
            </div>
            <div className="header-right">
              <UncontrolledDropdown className="drop-right">
                <DropdownToggle className="shadow-none d-flex h-100px align-items-center fn-moremenu-btn">
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="#333333"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M3.60038 0.268555C1.6659 0.268555 0.0922852 1.84228 0.0922852 3.77665C0.0922852 5.71102 1.66525 7.28464 3.60038 7.28464C5.53551 7.28464 7.10848 5.71102 7.10848 3.77665C7.10848 1.84228 5.53475 0.268555 3.60038 0.268555Z" />
                    <path d="M14.9541 0.268555C13.0198 0.268555 11.446 1.84228 11.446 3.77665C11.446 5.71102 13.0198 7.28464 14.9541 7.28464C16.8886 7.28464 18.4626 5.71102 18.4626 3.77665C18.4626 1.84228 16.8893 0.268555 14.9541 0.268555Z" />
                    <path d="M26.4917 7.28474C28.4258 7.28474 29.9998 5.71113 29.9998 3.77676C29.9998 1.84238 28.4271 0.268555 26.4917 0.268555C24.5564 0.268555 22.9836 1.84228 22.9836 3.77665C22.9836 5.71102 24.5576 7.28474 26.4917 7.28474Z" />
                    <path d="M3.50875 18.5257C5.44312 18.5257 7.01717 16.9524 7.01717 15.0177C7.01717 13.0829 5.44312 11.5093 3.50875 11.5093C1.57437 11.5093 0 13.083 0 15.0177C0 16.9524 1.57437 18.5257 3.50875 18.5257Z" />
                    <path d="M14.8628 18.5257C16.7969 18.5257 18.3709 16.9524 18.3709 15.0177C18.3709 13.0829 16.7982 11.5093 14.8628 11.5093C12.9278 11.5093 11.3547 13.0829 11.3547 15.0177C11.3547 16.9524 12.9285 18.5257 14.8628 18.5257Z" />
                    <path d="M26.4012 18.5257C28.3361 18.5257 29.9093 16.9524 29.9093 15.0177C29.9093 13.0829 28.3361 11.5093 26.4012 11.5093C24.4664 11.5093 22.8918 13.0829 22.8918 15.0177C22.8918 16.9524 24.4659 18.5257 26.4012 18.5257Z" />
                    <path d="M3.58931 22.7153C1.65494 22.7153 0.0805664 24.2886 0.0805664 26.2234C0.0805664 28.1575 1.65494 29.7314 3.58931 29.7314C5.52369 29.7314 7.0973 28.1582 7.0973 26.2234C7.0973 24.2886 5.52369 22.7153 3.58931 22.7153Z" />
                    <path d="M14.9433 22.7153C13.0088 22.7153 11.4346 24.2886 11.4346 26.2234C11.4346 28.1575 13.0083 29.7314 14.9433 29.7314C16.8774 29.7314 18.4513 28.1582 18.4513 26.2234C18.4513 24.2886 16.8774 22.7153 14.9433 22.7153Z" />
                    <path d="M26.4807 22.7153C24.5467 22.7153 22.9727 24.2886 22.9727 26.2234C22.9727 28.1575 24.5467 29.7314 26.4807 29.7314C28.4155 29.7314 29.9888 28.1582 29.9888 26.2234C29.9888 24.2886 28.4148 22.7153 26.4807 22.7153Z" />
                  </svg>
                </DropdownToggle>
                <DropdownMenu className="fn-moremenu-box">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6 col-sm-6 text-center">
                        <Link
                          to="/groups"
                          className="dropDown-link broder-right-1-ccc"
                        >
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="#999999"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M21.3379 13.0934H18.8907C18.5577 13.0934 18.2352 13.1389 17.9283 13.2226C17.3229 12.0325 16.087 11.2148 14.6628 11.2148H10.3372C8.91299 11.2148 7.67705 12.0325 7.07168 13.2226C6.7648 13.1389 6.44233 13.0934 6.10928 13.0934H3.66211C1.64282 13.0934 0 14.7362 0 16.7555V20.6675C0 21.8791 0.985693 22.8647 2.19727 22.8647H22.8027C24.0143 22.8647 25 21.8791 25 20.6675V16.7555C25 14.7362 23.3572 13.0934 21.3379 13.0934ZM6.67505 14.8771V21.4H2.19727C1.79341 21.4 1.46484 21.0714 1.46484 20.6675V16.7555C1.46484 15.5439 2.45054 14.5583 3.66211 14.5583H6.10928C6.30811 14.5583 6.50063 14.5853 6.68394 14.635C6.67866 14.7151 6.67505 14.7957 6.67505 14.8771ZM16.8601 21.4H8.13989V14.877C8.13989 13.6654 9.12559 12.6797 10.3372 12.6797H14.6628C15.8744 12.6797 16.8601 13.6654 16.8601 14.877V21.4ZM23.5352 20.6675C23.5352 21.0714 23.2066 21.4 22.8027 21.4H18.325V14.877C18.325 14.7956 18.3213 14.715 18.3161 14.635C18.4994 14.5853 18.6919 14.5582 18.8907 14.5582H21.3379C22.5495 14.5582 23.5352 15.5439 23.5352 16.7555V20.6675Z" />
                            <path d="M4.88555 6.17676C3.09116 6.17676 1.63135 7.63657 1.63135 9.43096C1.6313 11.2253 3.09116 12.6852 4.88555 12.6852C6.67988 12.6852 8.13975 11.2253 8.13975 9.43096C8.13975 7.63657 6.67993 6.17676 4.88555 6.17676ZM4.8855 11.2203C3.89883 11.2203 3.09614 10.4176 3.09614 9.43096C3.09614 8.44429 3.89883 7.6416 4.8855 7.6416C5.87217 7.6416 6.67485 8.44429 6.67485 9.43096C6.67485 10.4176 5.87217 11.2203 4.8855 11.2203Z" />
                            <path d="M12.5001 2.13525C10.1029 2.13525 8.15259 4.08555 8.15259 6.48281C8.15259 8.88008 10.1029 10.8304 12.5001 10.8304C14.8974 10.8304 16.8477 8.88008 16.8477 6.48281C16.8477 4.0856 14.8974 2.13525 12.5001 2.13525ZM12.5001 9.36553C10.9106 9.36553 9.61743 8.07236 9.61743 6.48281C9.61743 4.89331 10.9106 3.6001 12.5001 3.6001C14.0897 3.6001 15.3829 4.89326 15.3829 6.48281C15.3829 8.07236 14.0897 9.36553 12.5001 9.36553Z" />
                            <path d="M20.1143 6.17676C18.32 6.17676 16.8601 7.63657 16.8601 9.43096C16.8602 11.2253 18.32 12.6852 20.1143 12.6852C21.9087 12.6852 23.3685 11.2253 23.3685 9.43096C23.3685 7.63657 21.9087 6.17676 20.1143 6.17676ZM20.1143 11.2203C19.1277 11.2203 18.325 10.4176 18.325 9.43096C18.325 8.44429 19.1277 7.6416 20.1143 7.6416C21.101 7.6416 21.9037 8.44429 21.9037 9.43096C21.9037 10.4176 21.101 11.2203 20.1143 11.2203Z" />
                          </svg>
                          <p className="menu-text groups">Groups</p>
                        </Link>
                      </div>

                      <div className="col-md-6 col-sm-6 text-center">
                        <Link to="/adorders" className="dropDown-link">
                          <SvgArticle />
                          <p className="menu-text artical">My Paid Ads</p>
                        </Link>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-sm-6 text-center">
                        <Link
                          to="/article/all-article"
                          className="dropDown-link broder-right-1-ccc  pages"
                        >
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="#999999"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M24.5833 22.5H22.0833V13.7025C22.2202 13.7327 22.3598 13.7486 22.5 13.75C23.65 13.7486 24.582 12.8167 24.5833 11.6667C24.5833 11.6362 24.58 11.6059 24.5733 11.5763L23.74 7.82625C23.6976 7.63563 23.5286 7.50005 23.3333 7.5H22.0833V6.25C22.0833 6.0199 21.8968 5.83333 21.6667 5.83333H18.3333V5H19.1667C19.3968 5 19.5833 4.81344 19.5833 4.58333V0.416667C19.5833 0.186562 19.3968 0 19.1667 0H5.83333C5.60323 0 5.41667 0.186562 5.41667 0.416667V4.58333C5.41667 4.81344 5.60323 5 5.83333 5H6.66667V5.83333H3.33333C3.10323 5.83333 2.91667 6.0199 2.91667 6.25V7.5H1.66667C1.47141 7.50005 1.30234 7.63563 1.26 7.82625L0.426667 11.5763C0.42 11.6059 0.416667 11.6362 0.416667 11.6667C0.418021 12.8167 1.35 13.7486 2.5 13.75C2.64016 13.7486 2.77979 13.7327 2.91667 13.7025V22.5H0.416667C0.186562 22.5 0 22.6866 0 22.9167V24.5833C0 24.8134 0.186562 25 0.416667 25H24.5833C24.8134 25 25 24.8134 25 24.5833V22.9167C25 22.6866 24.8134 22.5 24.5833 22.5ZM23 8.33333L23.75 11.7083C23.7275 12.3823 23.1744 12.917 22.5 12.9167C22.2803 12.9166 22.0646 12.8581 21.875 12.7471C21.5833 12.5774 21.3722 12.2975 21.2892 11.9704C21.262 11.8715 21.2488 11.7693 21.25 11.6667C21.25 11.6514 21.2492 11.636 21.2475 11.6208L20.8821 8.33333H23ZM19.1667 15.8333H15C14.7699 15.8333 14.5833 16.0199 14.5833 16.25V22.5H3.75V13.3183C3.90755 13.202 4.04781 13.064 4.16667 12.9083C4.84625 13.8288 6.14333 14.0241 7.0638 13.3445C7.23016 13.2217 7.37719 13.0747 7.5 12.9083C8.17958 13.8288 9.47667 14.0241 10.3971 13.3445C10.5635 13.2217 10.7105 13.0747 10.8333 12.9083C11.5129 13.8288 12.81 14.0241 13.7305 13.3445C13.8968 13.2217 14.0439 13.0747 14.1667 12.9083C14.8462 13.8288 16.1433 14.0241 17.0638 13.3445C17.2302 13.2217 17.3772 13.0747 17.5 12.9083C18.1799 13.8288 19.4773 14.0238 20.3978 13.3439C20.5639 13.2212 20.7107 13.0744 20.8333 12.9083C20.9521 13.0636 21.0924 13.2013 21.25 13.3171V22.5H19.5833V16.25C19.5833 16.0199 19.3968 15.8333 19.1667 15.8333ZM18.75 16.6667V22.5H15.4167V16.6667H18.75ZM4.58333 11.6883L4.95833 8.33333H7.45333L7.08792 11.6208C7.08552 11.636 7.08401 11.6513 7.08333 11.6667C7.08432 11.7727 7.07026 11.8783 7.04167 11.9804C6.86568 12.648 6.18187 13.0465 5.51432 12.8705C5.07542 12.7548 4.73375 12.4103 4.62167 11.9704C4.59651 11.8785 4.58365 11.7836 4.58333 11.6883ZM7.91667 11.6883L8.29167 8.33333H10.4167V11.6667C10.4177 11.7727 10.4036 11.8783 10.375 11.9804C10.199 12.648 9.51521 13.0465 8.84766 12.8705C8.40875 12.7548 8.06708 12.4103 7.955 11.9704C7.92984 11.8785 7.91698 11.7836 7.91667 11.6883ZM11.25 11.6667V8.33333H13.75V11.6667C13.751 11.7727 13.7369 11.8783 13.7083 11.9804C13.5323 12.648 12.8485 13.0465 12.181 12.8705C11.7421 12.7548 11.4004 12.4103 11.2883 11.9704C11.2614 11.8715 11.2485 11.7692 11.25 11.6667ZM14.5833 11.6667V8.33333H16.7083L17.0833 11.6883C17.0822 11.787 17.0682 11.885 17.0417 11.98C16.8657 12.6476 16.1819 13.046 15.5143 12.8701C15.0754 12.7544 14.7337 12.4098 14.6217 11.97C14.5948 11.8712 14.5819 11.7691 14.5833 11.6667ZM17.5487 8.33333H20.0437L20.4188 11.6883C20.4177 11.787 20.4036 11.885 20.3771 11.98C20.2011 12.6476 19.5173 13.046 18.8497 12.8701C18.4108 12.7544 18.0692 12.4098 17.9571 11.97C17.9295 11.8713 17.9159 11.7692 17.9167 11.6667C17.9167 11.6514 17.9158 11.636 17.9142 11.6208L17.5487 8.33333ZM6.25 4.16667V0.833333H18.75V4.16667H6.25ZM17.5 5V5.83333H7.5V5H17.5ZM3.75 6.66667H21.25V7.5H3.75V6.66667ZM2.5 12.9167C1.82557 12.917 1.2725 12.3823 1.25 11.7083L2 8.33333H4.11708L3.75167 11.6208C3.75026 11.6361 3.74974 11.6514 3.75 11.6667C3.75083 11.7724 3.73677 11.8778 3.70833 11.9796C3.62432 12.3031 3.41422 12.5795 3.125 12.7471C2.93542 12.8581 2.71969 12.9166 2.5 12.9167ZM24.1667 24.1667H0.833333V23.3333H24.1667V24.1667Z" />
                            <path d="M12.5001 15.8335H5.83341C5.60331 15.8335 5.41675 16.0201 5.41675 16.2502V20.4168C5.41675 20.6469 5.60331 20.8335 5.83341 20.8335H12.5001C12.7302 20.8335 12.9167 20.6469 12.9167 20.4168V16.2502C12.9167 16.0201 12.7302 15.8335 12.5001 15.8335ZM12.0834 20.0002H6.25008V16.6668H12.0834V20.0002Z" />
                          </svg>
                          <p className="menu-text">Articles</p>
                        </Link>
                      </div>
                      <div className="col-md-6 col-sm-6 text-center">
                        <Link to="/adcart" className="dropDown-link">
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="#999999"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10.2519 6.41444V9.16483C10.2519 10.6816 11.485 11.9156 13.0006 11.9156H17.9992C19.5148 11.9156 20.7479 10.6816 20.7479 9.16483V6.38354C20.911 6.4913 21.0979 6.54566 21.2846 6.54566C21.5509 6.54566 21.8162 6.43733 22.0088 6.22428C22.3707 5.82449 22.34 5.20709 21.9402 4.84526L17.3902 0.727297C16.3259 -0.243734 14.7228 -0.243734 13.6587 0.727297L9.10849 4.84526C8.70871 5.20709 8.678 5.82449 9.03982 6.22428C9.35435 6.57179 9.86189 6.64027 10.2519 6.41444ZM14.9703 2.17383C14.9715 2.17269 14.9728 2.17154 14.974 2.17059C15.2877 1.88372 15.7609 1.88372 16.0747 2.17059C16.0758 2.17154 16.077 2.17269 16.0783 2.17383L18.8005 4.63755C18.7971 4.67093 18.7951 4.70488 18.7951 4.73921V9.16483C18.7951 9.60486 18.4381 9.96287 17.9992 9.96287H13.0006C12.5617 9.96287 12.2047 9.60486 12.2047 9.16483V4.73921C12.2047 4.71919 12.2028 4.69935 12.2016 4.67951L14.9703 2.17383ZM23.0424 19.1408V18.1214C23.0424 16.8801 22.0323 15.8699 20.7906 15.8699H11.4234C10.8852 15.8699 10.4471 16.308 10.4471 16.8463C10.4471 17.0777 10.5285 17.2903 10.6636 17.4578L10.8617 17.639C10.8676 17.6443 10.8728 17.6504 10.8787 17.6562C11.0345 17.7613 11.222 17.8227 11.4234 17.8227H16.3055C16.8447 17.8227 17.2819 18.2598 17.2819 18.799C17.2819 19.3382 16.8447 19.7754 16.3055 19.7754H11.4234C10.5747 19.7754 9.80944 19.4123 9.27386 18.8334L3.63821 13.6837C3.62963 13.6757 3.62124 13.6679 3.61284 13.6597C3.42669 13.477 3.17988 13.3782 2.91991 13.3803C2.65917 13.3826 2.41484 13.4865 2.23231 13.6727C2.04958 13.8588 1.95021 14.1051 1.95269 14.3658C1.95517 14.6225 2.05588 14.8632 2.23669 15.045L7.20496 19.645C7.2103 19.6499 7.21564 19.6551 7.22079 19.66C9.47623 21.8437 12.4473 23.0463 15.5866 23.0463H24.0188C24.558 23.0463 24.9952 23.4835 24.9952 24.0227C24.9952 24.5619 24.558 24.9991 24.0188 24.9991H15.5866C13.7805 24.9991 12.0157 24.6554 10.3414 23.9777C8.67056 23.3013 7.16643 22.3232 5.87057 21.0707L0.897925 16.4667C0.891059 16.4603 0.884192 16.4538 0.877326 16.4473C0.319045 15.8991 0.00738403 15.1665 0.000136088 14.3841C-0.0073026 13.6017 0.290435 12.8634 0.838416 12.3049C1.3864 11.7466 2.1192 11.435 2.90159 11.4275C3.67579 11.4205 4.41031 11.7131 4.96706 12.2526L8.7316 15.6925C9.1804 14.6496 10.218 13.9172 11.4234 13.9172H20.7906C23.109 13.9172 24.9952 15.8034 24.9952 18.1216V19.1408C24.9952 19.68 24.558 20.1172 24.0188 20.1172C23.4796 20.1172 23.0424 19.68 23.0424 19.1408Z" />
                          </svg>
                          <p className="menu-text real-state">Ad Cart</p>
                        </Link>
                      </div>
                    </div>
                    {/*<div className="row justify-content-center">
                      <div className="col-md-12 col-sm-12 text-center">
                        <Link to="/services" className="dropDown-link">
                          <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="#999999"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0)">
                              <path d="M24.218 12.3334C23.3821 11.6445 22.0609 11.5854 21.1938 12.5161L19.0411 14.8269C18.7627 13.9325 17.9273 13.2811 16.9426 13.2811H13.101C12.8095 13.2811 12.7119 13.1698 12.2056 12.7797C10.275 11.0967 7.37529 11.1021 5.45059 12.7958L4.03857 14.0389C3.40386 13.703 2.6627 13.6947 2.02451 14.0135L0.404981 14.823C0.0431644 15.0042 -0.103271 15.4441 0.0773441 15.8059L4.47163 24.5944C4.65278 24.9562 5.09268 25.1027 5.45449 24.9221L7.07402 24.112C7.87231 23.7132 8.3166 22.8987 8.28779 22.0697H16.9425C18.5474 22.0697 20.081 21.3032 21.0438 20.0191L24.5598 15.3309C25.2418 14.4222 25.1339 13.0897 24.218 12.3334ZM6.41875 22.802L5.45444 23.2844L1.71494 15.8059L2.67974 15.3235C3.04155 15.1429 3.48096 15.2889 3.66211 15.6512L6.74639 21.8197C6.92705 22.1815 6.78057 22.6209 6.41875 22.802ZM23.3879 14.452L19.8721 19.1402C19.1841 20.0576 18.089 20.6049 16.9426 20.6049H7.77661L5.03213 15.1155L6.41826 13.8954C7.79756 12.6821 9.87754 12.6821 11.2568 13.8954C12.0693 14.6107 12.5746 14.7459 13.101 14.7459H16.9425C17.3463 14.7459 17.6749 15.0745 17.6749 15.4783C17.6749 15.8821 17.3463 16.2107 16.9425 16.2107H13.2021C12.7978 16.2107 12.4697 16.5388 12.4697 16.9431C12.4697 17.3473 12.7978 17.6754 13.2021 17.6754H17.4333C18.0411 17.6754 18.6271 17.4205 19.0411 16.9758L22.2655 13.5145C22.5604 13.1981 23.0125 13.2245 23.2898 13.4672C23.5798 13.721 23.6111 14.1551 23.3879 14.452Z" />
                              <path d="M15.3997 4.99824C15.9011 4.47241 16.2102 3.76152 16.2102 2.97881C16.2102 1.3666 14.9076 0.000488281 13.2807 0.000488281C11.6661 0.000488281 10.3024 1.36416 10.3024 2.97881C10.3024 3.73755 10.5998 4.45381 11.1397 5.0041C9.80049 5.75503 8.83765 7.19634 8.83765 8.88667V9.61904C8.83765 10.0233 9.16577 10.3514 9.57002 10.3514H16.9426C17.3469 10.3514 17.675 10.0233 17.675 9.61904V8.88667C17.6749 7.22954 16.7635 5.76577 15.3997 4.99824ZM13.2807 1.46528C14.0746 1.46528 14.7454 2.15859 14.7454 2.97886C14.7454 3.78643 14.0883 4.4436 13.2807 4.4436C12.4604 4.4436 11.7671 3.77275 11.7671 2.97886C11.7671 2.17275 12.4746 1.46528 13.2807 1.46528ZM10.3024 8.88667C10.3024 7.27202 11.6661 5.90835 13.2807 5.90835C14.8958 5.90835 16.2102 7.24419 16.2102 8.88667H10.3024Z" />
                            </g>
                            <defs>
                              <clipPath id="clip0">
                                <rect width="25" height="25" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <p className="menu-text services">Services</p>
                        </Link>
                      </div>
                    </div> */}
                  </div>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </div>
        </div>
        <Toaster />
      </>
    );
  }
}
export default withNavigate(Header);
